import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Paper, Box, Typography } from "@mui/material";
import axios from "axios";
import { format } from "date-fns";
import { differenceInDays, parseISO } from "date-fns";
import { Tooltip } from "@mui/material";
import { CheckCircle, Warning, Error, VisibilityOff, Visibility } from "@mui/icons-material";

const DataTableSwitchCase = ({ endpoint, branches }) => {

    const [expandedRow, setExpandedRow] = useState()

    const [selectedBranch, setSelectedBranch] = useState([]);
    const [selectedBranchCode, setSelectedBranchCode] = useState(null);

    const handleRowClick = (valuefromClick) => {
        console.log("handleRowClick", valuefromClick)
        setExpandedRow(prev => (prev === valuefromClick.id ? null : valuefromClick.id));
    };

    console.log("endpoint DataTableSwitchCase", endpoint)

    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"


    useEffect(() => {
        console.log('selectedbranchCode', selectedBranchCode)

        if (selectedBranchCode && endpoint) {

            const selected = branches?.find(
                (branch) => branch.DEPTNO === selectedBranchCode
            );
            setSelectedBranch(selected);
            console.log('selected', selected)

            fetchTableData();

        }
    }, [selectedBranchCode, endpoint])

    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const pageSize = 20;

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure two digits for month
        const day = String(today.getDate()).padStart(2, "0"); // Ensure two digits for day
        return `${year}-${month}-${day}`;
    };

    const todayDate = getTodayDate();


    useEffect(() => {

        // Automatically select the first branch
        if (branches.length > 0) {
            //   setSelectedBranch(branchArray[0].DEPTNO);
            setSelectedBranch(branches[0]);
            setSelectedBranchCode(branches[0].DEPTNO)
        }

    }, [branches])

    const fetchTableData = async () => {

        let fromDate = "2024-01-01"
        if(endpoint == "Todays_Sales_Branch"){
            fromDate = todayDate
        }
        try {
            let apiUrl = `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/${selectedBranchCode}/${endpoint}/${fromDate}/${todayDate}/-/-/-/-/-`

            console.log("apiUrl DataTableSwitchCase", apiUrl)

            const response = await axios.get(
                // `https://cubixweberp.com:213/api/HRDashboard/SUNRISE/MAIN/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
                apiUrl
            );
            const data = response.data;
            console.log("data>>>++", response.data);
            if (endpoint === "CRM_CUSTOMER_AQUI") {
                console.log("CRM_SALESMAN_PERFORM data:", data);
            }
            setTableData(data);
        } catch (error) {
            console.error("Error while fetching table data", error);
        }
    };


    const getColumn = () => {

        if (endpoint == "Current_Stock_Position") {
            return [
                { field: "GROUP", headerName: "Group", width: 110, sortable: false },
                { field: "CurrentQty", headerName: "Current Qty", width: 110, sortable: false },
                { field: "StockValue", headerName: "Stock Value", width: 110, sortable: false },
            ]
        } else if (endpoint == "Stock_By_Location") {
            return [
                { field: "StoreLocationCode", headerName: "Store Location Code", width: 110, sortable: false },
                { field: "StoreName", headerName: "Store Name", width: 110, sortable: false },
                { field: "BranchCode", headerName: "Branch Code", width: 110, sortable: false },
                { field: "BranchName", headerName: "Branch Name", width: 110, sortable: false },
                { field: "ItemCount", headerName: "ItemCount", width: 110, sortable: false },
                { field: "TotalQty", headerName: "TotalQty", width: 110, sortable: false },
                { field: "StockValue", headerName: "Stock Value", width: 110, sortable: false },
            ]
        } else if (endpoint == "Fast_Moving_Items_90Days_Top50") {
            return [
                { field: "ItemCode", headerName: "Item Code", width: 110, sortable: false },
                { field: "ItemDescription", headerName: "Item Description", width: 110, sortable: false },
                { field: "group", headerName: "Group", width: 110, sortable: false },
                { field: "TotalSoldQty", headerName: "Total Sold Qty", width: 110, sortable: false },
                { field: "TransactionCount", headerName: "Transaction Count", width: 110, sortable: false },
            ]
        } else if (endpoint == "Non_Moving_Items_90Days") {
            return [
                { field: "ItemCode", headerName: "Item Code", width: 110, sortable: false },
                { field: "ItemDescription", headerName: "Item Description", width: 110, sortable: false },
                { field: "CurrentQty", headerName: "CurrentQty", width: 110, sortable: false },
                { field: "AvgCost", headerName: "AvgCost", width: 110, sortable: false },
                { field: "StockValue", headerName: "StockValue", width: 110, sortable: false },
            ]
        } else if (endpoint == "Inventory_Valuation_Report") {
            return [
                {
                    field: "ItemGroup", headerName: "Item Group", flex: 1, sortable: false, renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "TotalQty", headerName: "Item Description",flex:1, sortable: false },
                { field: "TotalQty", headerName: "TotalQty", flex: 1, sortable: false },
            ]
        } else if (endpoint == "Stock_Aging_Report") {
            return [
                // { field: ["0-30 Days"], headerName: "0-30 Days", width: 110, sortable: false },
                // { field: ["31-60 Days"], headerName: "31-60 Days", width: 110, sortable: false },
                // { field: ["61-90 Days"], headerName: "61-90 Days", width: 110, sortable: false },
                // { field: ["91-180 Days"], headerName: "91-180 Days", width: 110, sortable: false },
                // { field: ["180+ Days"], headerName: "180+ Days", width: 110, sortable: false },
                {
                    field: "ItemGroup", headerName: "ItemGroup", flex: 1, sortable: false, renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                { field: "TotalValue", headerName: "Total Value", flex: 1, sortable: false },
            ]
        } else if (endpoint == "Todays_Sales_Branch") {
            return [
                // { field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false },
                {
                    field: "Branch_Name", headerName: "Branch_Name", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 110, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 110, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 110, sortable: false },
                // { field: "CreditReturn", headerName: "CreditReturn", width: 110, sortable: false },
                { field: "NetAmount", headerName: "NetAmount", type: "number", flex: 1, sortable: false },
            ]
        } else if (endpoint == "Todays_Sales_Branch_Salesperson") {
            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "Salesman", headerName: "Salesman", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                // { field: "CreditReturn", headerName: "CreditReturn", width: 0, sortable: false },
                {
                    field: "NetAmount", headerName: "NetAmount", type: "number", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        } else if (endpoint == "Slow_Moving_Items_90Days") {

            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "ItemCode", headerName: "Item Code", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                // { field: "CreditReturn", headerName: "CreditReturn", width: 0, sortable: false },
                {
                    field: "TotalSoldQty", headerName: "Total Sold Qty", type: "number", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        } else if (endpoint == "CASH_FUND_FORCAST_30DAYS") {
            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "OpeningBalance", headerName: "Opening Balance", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                // { field: "CreditReturn", headerName: "CreditReturn", width: 0, sortable: false },
                {
                    field: "ProjectedClosingBalance", headerName: "Projected Closing Balance", type: "number", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        } else if (endpoint == "Seasonal_Demand_Patterns") {
            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "code", headerName: "Code", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                // { field: "CreditReturn", headerName: "CreditReturn", width: 0, sortable: false },
                {
                    field: "TotalLandedCost", headerName: "Total Landed Cost", type: "number", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        } else if (endpoint == "AGEINGREPORT") {
            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "CustomerName", headerName: "CustomerName", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                // { field: "CreditReturn", headerName: "CreditReturn", width: 0, sortable: false },
                {
                    field: "Total_Amount", headerName: "Total Amount", type: "number", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        } else if (endpoint == "Last_30Days_Sales_vs_Receipts") {
            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "Date", headerName: "Date", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                { field: "Receipt_Amount", headerName: "Receipt Amount", flex: 1, sortable: false },
                {
                    field: "Sales_Amount", headerName: "Sales Amount", type: "number", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        } else if (endpoint == "SalesVsReceipt_Monthly") {
            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "Metric", headerName: "Metric", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                // { field: "CreditReturn", headerName: "CreditReturn", width: 0, sortable: false },
                {
                    field: "Department", headerName: "Department", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        } else if (endpoint == "SALESMAN_MONTHPERFORMANCE") {
            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "sman_name", headerName: "Name", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                // { field: "CreditReturn", headerName: "CreditReturn", width: 0, sortable: false },
                {
                    field: "TotalSales", headerName: "Total Sales", type: "number", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        } else if (endpoint == "Cash_And_Bank_Position") {
            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "Account_Name", headerName: "Name", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                { field: "Opening_Balance", headerName: "Opening Balance", width: 0, sortable: false },
                {
                    field: "Closing_Balance", headerName: "Closing Balance", type: "number", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        }
        else if (endpoint == "PURCHASE_IMPORT_CURRENT_VS_LAST") {
            return [
                // {field: "Branch_ID", headerName: "Branch ID", width: 110, sortable: false, sortable: false, },
                // { field: "Branch_Name", headerName: "Branch_Name", width: 0, sortable: false },
                {
                    field: "CODE", headerName: "CODE", flex: 1, sortable: false,
                    renderCell: (params) => {
                        if (params.row.isExpanded) {
                            return (
                                <Box sx={{ padding: 1 }}>

                                    {params.row.content}

                                </Box>
                            );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                },
                // { field: "CashSale", headerName: "CashSale", width: 0, sortable: false },
                // { field: "CreditSale", headerName: "CreditSale", width: 0, sortable: false },
                // { field: "CashReturn", headerName: "CashReturn", width: 0, sortable: false },
                // { field: "Opening_Balance", headerName: "Opening Balance", width: 0, sortable: false },
                {
                    field: "CostChangePercent", headerName: "CostChangePercent", type: "number", flex: 1, sortable: false, renderCell: (params) => {

                        return (
                            <Box sx={{ paddingRight: 1 }}>

                                {params.value}

                            </Box>
                        );

                    },
                },
            ]
        }






    }

    const columns = getColumn()


    const getRow = () => {

        if (endpoint == "Current_Stock_Position") {
            return tableData.map((item, index) => ({
                id: item.GROUP,
                GROUP: item.GROUP,
                CurrentQty: item.CurrentQty,
                StockValue: item.StockValue,
            }))
        } else if (endpoint == "Stock_By_Location") {
            return tableData.map((item, index) => ({
                id: item.StoreLocationCode,
                StoreLocationCode: item.StoreLocationCode,
                StoreName: item.StoreName,
                BranchCode: item.BranchCode,
                BranchName: item.BranchName,
                ItemCount: item.ItemCount,
                TotalQty: item.TotalQty,
                StockValue: item.StockValue

            }))
        } else if (endpoint == "Fast_Moving_Items_90Days_Top50") {
            return tableData.map((item, index) => ({
                id: item.ItemCode,
                ItemCode: item.ItemCode,
                ItemDescription: item.ItemDescription,
                group: item.group,
                TotalSoldQty: item.TotalSoldQty,
                TransactionCount: item.TransactionCount

            }))
        } else if (endpoint == "Non_Moving_Items_90Days") {
            return tableData.map((item, index) => ({
                id: item.ItemCode,
                ItemCode: item.ItemCode,
                ItemDescription: item.ItemDescription,
                CurrentQty: item.CurrentQty,
                AvgCost: item.AvgCost,
                StockValue: item.StockValue

            }))
        } else if (endpoint == "Inventory_Valuation_Report") {
            return tableData.map((item, index) => ({
                id: item.ItemGroup,
                ItemGroup: item.ItemGroup,
                TotalQty: item.TotalQty,
                TotalValue: item.TotalValue,

            }))
        } else if (endpoint == "Stock_Aging_Report") {
            return tableData.map((item, index) => ({
                id: item.ItemGroup,
                ItemGroup: item.ItemGroup,
                ["0-30 Days"]: item["0-30 Days"],
                ["31-60 Days"]: item["31-60 Days"],
                ["61-90 Days"]: item["61-90 Days"],
                ["91-180 Days"]: item["91-180 Days"],
                ["180+ Days"]: item["180+ Days"],
                TotalValue: item.TotalValue

            }))
        } else if (endpoint == "Todays_Sales_Branch") {
            return tableData.map((item, index) => ({
                id: item.Branch_ID,
                Branch_ID: item.Branch_ID,
                Branch_Name: item.Branch_Name,
                CashSale: item.CashSale,
                CreditSale: item.CreditSale,
                CashReturn: item.CashReturn,
                CreditReturn: item.CreditReturn,
                NetAmount: item.NetAmount

            }))
        } else if (endpoint == "Todays_Sales_Branch_Salesperson") {
            return tableData.map((item, index) => ({
                id: item.Salesman,
                Branch_ID: item.Branch_ID,
                Branch_Name: item.Branch_Name,
                Salesman: item.Salesman,
                CashSale: item.CashSale,
                CreditSale: item.CreditSale,
                CashReturn: item.CashReturn,
                CreditReturn: item.CreditReturn,
                NetAmount: item.NetAmount,

            }))
        } else if (endpoint == "Slow_Moving_Items_90Days") {
            return tableData.map((item, index) => ({
                id: item.ItemCode,
                ItemCode: item.ItemCode,
                ItemDescription: item.ItemDescription,
                TotalSoldQty: item.TotalSoldQty,
                TransactionCount: item.TransactionCount

            }))
        } else if (endpoint == "CASH_FUND_FORCAST_30DAYS") {
            return tableData.map((item, index) => ({
                id: item.ExpectedInflows,
                ExpectedInflows: item.ExpectedInflows,
                ExpectedOutflows: item.ExpectedOutflows,
                ForecastFrom: item.ForecastFrom,
                OpeningBalance: item.OpeningBalance,
                PDC_Issued: item.PDC_Issued,
                PDC_Received: item.PDC_Received,
                ProjectedClosingBalance: item.ProjectedClosingBalance

            }))
        } else if (endpoint == "Inventory_Cost_Summary") {
            return tableData.map((item, index) => ({
                id: item.ExpectedInflows,
                ExpectedInflows: item.ExpectedInflows,
                ExpectedOutflows: item.ExpectedOutflows,
                ForecastFrom: item.ForecastFrom,
                OpeningBalance: item.OpeningBalance,
                PDC_Issued: item.PDC_Issued,
                PDC_Received: item.PDC_Received,
                ProjectedClosingBalance: item.ProjectedClosingBalance

            }))
        } else if (endpoint == "Seasonal_Demand_Patterns") {
            return tableData.map((item, index) => ({
                id: item.code,
                ItemGroup: item.ItemGroup,
                TotalLandedCost: item.TotalLandedCost,
                TotalOtherCost: item.TotalOtherCost,
                TotalPurchaseCost: item.TotalPurchaseCost,
                TotalQty: item.TotalQty,
                code: item.code,
                desc: item.desc

            }))
        } else if (endpoint == "AGEINGREPORT") {
            return tableData.map((item, index) => ({
                id: item.CustomerName,
                ["Age_0_30"]: item["Age_0_30"],
                ["Age_31_60"]: item["Age_31_60"],
                ["Age_61_90"]: item["Age_61_90"],
                ["Age_91_120"]: item["Age_91_120"],
                ["Age_Above120"]: item["Age_Above120"],
                CustomerName: item.CustomerName,
                Sales_Person: item.Sales_Person,
                Total_Amount: item.Total_Amount


            }))
        } else if (endpoint == "Last_30Days_Sales_vs_Receipts") {
            return tableData.map((item, index) => ({
                id: index,
                Date: item.Date,
                Department: item.Department,
                Receipt_Amount: item.Receipt_Amount,
                Sales_Amount: item.Sales_Amount


            }))
        } else if (endpoint == "SalesVsReceipt_Monthly") {
            return tableData.map((item, index) => ({
                id: index,
                Department: item.Department,
                Metric: item.Metric


            }))
        } else if (endpoint == "SALESMAN_MONTHPERFORMANCE") {
            return tableData.map((item, index) => ({
                id: item.sman_key,
                sman_name: item.sman_name,
                TotalSales: item.TotalSales,
                AvgMonthlySales: item.AvgMonthlySales


            }))
        } else if (endpoint == "Cash_And_Bank_Position") {
            return tableData.map((item, index) => ({
                id: item.Account_Code,
                Account_Code: item.Account_Code,
                Account_Name: item.Account_Name,
                Account_Type: item.Account_Type,
                Closing_Balance: item.Closing_Balance,
                GROUP: item.GROUP,
                Opening_Balance: item.Opening_Balance,
                Payments: item.Payments,
                Receipts: item.Receipts


            }))
        } else if (endpoint == "PURCHASE_IMPORT_CURRENT_VS_LAST") {
            return tableData.map((item, index) => ({
                id: index,
                CODE:item.CODE,
                ItemName: item.ItemName,
                CostChangePercent: item.CostChangePercent,
                CurrentInvNo:item.CurrentInvNo,
                CurrentLandedCost:item.CurrentLandedCost,
                CurrentOtherCost:item.CurrentOtherCost,
                CurrentSupplier:item.CurrentSupplier,
                CurrentUnitPrice:item.CurrentUnitPrice,
                DESCRIPTION:item.DESCRIPTION,
                LastInvNo:item.LastInvNo,
                LastLandedCost:item.LastLandedCost,
                LastOtherCost:item.LastOtherCost,
                LastSupplier:item.LastSupplier,
                LastUnitPrice:item.LastUnitPrice



            }))
        }



    }
    const rows = getRow()

    const getRowsWithExpansion = () => {
        const result = [];
        rows.forEach((row) => {
            result.push(row);
            if (row.id === expandedRow) {
                result.push({
                    id: `${row.id}-expanded`,
                    isExpanded: true,
                    parentId: row.id,
                    content: Object.keys(row).map((item) => <p>{item}{""}<span style={{ fontWeight: "600", marginLeft: "10px" }}>{row[item]}</span></p>)
                });
            }
        });
        return result;
    };


    const getRowHeight = (params) => {
        if (params.model?.isExpanded) {
            return 'auto';
        }
        return 'auto'; // Let the row size to fit content (if needed)
    };

    return (
        <div className="w-full overflow-x-auto">

            <div className="flex justify-between items-center mb-2">
                <div className="flex justify-left gap-4 items-center mb-2">

                    {selectedBranch && (
                        <div className="mt-2 text-sm text-gray-700">
                            Selected Branch:{" "}
                            <strong>
                                {selectedBranch.deptnodesc} ({selectedBranch.DEPTNO})
                            </strong>
                        </div>
                    )}
                </div>

                <select
                    value={selectedBranch?.DEPTNO || ""}
                    onChange={(e) => setSelectedBranchCode(e.target.value)}
                    className="border border-gray-300 rounded px-2 py-1 text-sm"
                >
                    {branches?.map((branch) => (
                        <option key={branch.DEPTNO} value={branch.DEPTNO}>
                            {branch.deptnodesc}
                        </option>
                    ))}
                </select>
            </div>


            {(rows && columns) ?
                <Paper>
                    <DataGrid
                        disableColumnMenu
                        disableColumnFilter
                        disableColumnSelector

                        checkboxSelection={false}
                        rows={getRowsWithExpansion()}
                        getRowHeight={getRowHeight}
                        columns={columns}
                        pagination
                        paginationMode="server"
                        page={page}
                        pageSizeOptions={[pageSize]}
                        rowCount={rows?.length}
                        onPageChange={(newPage) => setPage(newPage)}
                        onRowClick={handleRowClick}
                        sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeaderTitle": {
                                whiteSpace: "normal",
                            },
                            "& .MuiDataGrid-columnHeader": {
                                fontFamily: "'Figtree', sans-serif",
                                background: "#27446A",
                                color: "#F8F8F8",
                            },
                            "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer":
                            {
                                color: "#FFFFFF", // hide the "Select All" label space
                            },
                            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                                color: "#FFFFFF", // unselected checkbox color
                            },
                            "& .MuiDataGrid-columnHeaderCheckbox .Mui-checked": {
                                color: "#FFFFFF", // selected checkbox color
                            },
                            "& .MuiDataGrid-cell": {
                                padding: "1px 2px",
                                fontFamily: "'Figtree', sans-serif",
                            },
                        }}
                    />
                </Paper>
                :
                <div>No data found</div>
            }
        </div>
    );
};

export default DataTableSwitchCase;